import { Member } from '../../../../api/groups';

export default function renderStudent(member: Member) {
  return `${member.lastName} ${member.firstName}`;
}
